import {ComponentProps, FC} from 'react';

export const IconLogoApp: FC<ComponentProps<'svg'>> = ({
    width = '180',
    height = '180',
    ...rest
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 180 180"
            fill="none"
            {...rest}
        >
            <rect
                width={180}
                height={180}
                rx={36}
                fill="var(--raw-primary-brand)"
            />
            <path
                d="M64.6203 25.7658C67.6043 25.4524 70.448 26.3924 73.191 27.6488C75.9558 28.9151 79.3167 30.8483 83.431 33.208L143.752 67.8031C147.875 70.1677 151.247 72.0966 153.739 73.8453C156.21 75.5799 158.456 77.56 159.678 80.2904C161.44 84.2255 161.441 88.7199 159.678 92.655C158.456 95.3853 156.21 97.3655 153.739 99.1001C151.247 100.849 147.875 102.778 143.752 105.142L123.876 116.542L119.107 108.674L139.142 97.1847C143.422 94.7297 146.354 93.0432 148.417 91.5951C150.499 90.1334 151.059 89.3336 151.246 88.9166C151.943 87.3611 151.943 85.5843 151.246 84.0288C151.06 83.6118 150.5 82.8123 148.417 81.3503C146.354 79.9022 143.422 78.2157 139.142 75.7607L78.8208 41.1656C74.5488 38.7155 71.6191 37.0404 69.3304 35.9921C67.0208 34.9342 66.0463 34.852 65.5897 34.8998C63.8893 35.0786 62.3442 35.9672 61.3394 37.3438C61.0697 37.7136 60.6548 38.5946 60.4226 41.1131C60.1924 43.6095 60.1875 46.9715 60.1875 51.8776V55.2054L50.9621 47.9764C50.9773 44.9791 51.0318 42.4135 51.229 40.2741C51.5049 37.2822 52.1067 34.3618 53.8698 31.946C56.4115 28.4639 60.3188 26.2179 64.6203 25.7658Z"
                fill="var(--color-icon-invert-fixed)"
            />
            <path
                d="M68.9806 148.295L115.578 121.446L72.9698 57.8574L63.7381 69.8686L50.9558 59.2705V76.2275L19 125.165L26.6856 137.311L66.9504 117.907L68.9806 148.295Z"
                fill="var(--color-icon-invert-fixed)"
            />
        </svg>
    );
};
